<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    label="Проекты сбора данных"
    no-data-text="Проект не найден"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { DataCollectionsApi as Api } from '@/api/resources'

import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'

export default {
  name: 'BAutocompleteDataCollection',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new Api()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(params, ...args) {
      return this.adapter.api.getAll(params, args)
    },
  },
}
</script>
